import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Layout from "../components/Layout";
import { useAuth } from "../hooks/useAuth";
import { useBranding } from "../hooks/useBranding";
import { paymentLabels } from "../lib/constants";

// #77 - My Profile: a read-only view of the agent's details on file (the same
// safe fields the session already carries; no SSN or DOB shown).
const Field = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="textSecondary" display="block">
      {label}
    </Typography>
    <Typography variant="body1">{value || "—"}</Typography>
  </Grid>
);

const MyProfile = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { branding } = useBranding();
  const a = user?.agent || {};
  const cityStateZip = [a.city, a.state, a.zip].filter(Boolean).join(", ");

  return (
    <Layout>
      <Box sx={{ padding: 4, maxWidth: 900, margin: "0 auto" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/")}
          sx={{ mb: 1 }}
        >
          Back to dashboard
        </Button>
        <Typography variant="h5" sx={{ mb: 0.5 }}>
          My Profile
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Your details on file with {branding?.name || "Applied GA"}. To update
          anything, contact your agency or Applied GA.
        </Typography>
        <Paper variant="outlined" sx={{ padding: 3 }}>
          <Grid container spacing={2}>
            <Field label="First Name" value={a.firstName || user?.firstName} />
            <Field label="Last Name" value={a.lastName || user?.lastName} />
            <Field label="Preferred Name" value={a.preferredName} />
            <Field label="Individual NPN" value={a.npn} />
            <Field label="E-Mail" value={a.email || user?.email} />
            <Field label="Phone" value={a.phone} />
            <Field label="Address" value={a.address} />
            <Field label="City / State / Zip" value={cityStateZip} />
            <Field
              label="Licensed States"
              value={(a.licensedStates || []).join(", ")}
            />
            <Field label="Recommended by (FSD)" value={a.fsd} />
            <Field
              label="Payment Method"
              value={paymentLabels[a.payment] || a.payment}
            />
          </Grid>
        </Paper>
      </Box>
    </Layout>
  );
};

export default MyProfile;
